import { render } from "./checkboxChallange.vue?vue&type=template&id=3d53589e&scoped=true"
import script from "./checkboxChallange.vue?vue&type=script&lang=js"
export * from "./checkboxChallange.vue?vue&type=script&lang=js"

import "./checkboxChallange.vue?vue&type=style&index=0&id=3d53589e&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d53589e"]])

export default __exports__